<input #dt
  type="text"
  placeholder={{placeholder}}
  class="form-control datepick"
  [(ngModel)]="value"
  (ngModelChange)="bsValueChange($event)"
  bsDatepicker
  readonly
/>
<fa-icon [icon]="faCalendarAlt" class="faiconstyle" aria-hidden="true"  (click)="dt.click()"></fa-icon>